var render = function render(){var _vm=this,_c=_vm._self._c;return _c('skeleton-loading',[_c('row',[_c('square-skeleton',{attrs:{"boxProperties":{bottom: '10px', height: '30px'}}})],1),_c('row',[_c('square-skeleton',{attrs:{"boxProperties":{bottom: '10px', height: '200px'}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }